export const Name = 'olapic-popup-product-clicked';
export const OlapicPopupProductClicked = Name;
